import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";
import type {
  FantasyLeaderboardEntry,
  FantasyLeaderboardStats,
  TopPlayer,
  TopCaptain,
} from "@/types/api.types";

export const leaderboardService = {
  getGlobal: async (
    limit = 100,
    offset = 0,
  ): Promise<{ leaderboard: FantasyLeaderboardEntry[]; fromCache: boolean }> =>
    apiClient.get(
      `${API_ENDPOINTS.FANTASYLEADERBOARD.GLOBAL}?limit=${limit}&offset=${offset}`,
    ),

  getLeague: async (
    leagueId: number,
    limit = 100,
    offset = 0,
  ): Promise<{ leaderboard: FantasyLeaderboardEntry[]; fromCache: boolean }> =>
    apiClient.get(
      `${API_ENDPOINTS.FANTASYLEADERBOARD.LEAGUE(leagueId)}?limit=${limit}&offset=${offset}`,
    ),

  getLeaderboardByGameweek: async (
    gameweekId: number,
  ): Promise<{ leaderboard: (FantasyLeaderboardEntry & { gameweekPoints?: number })[]; fromCache: boolean }> => {
    return await apiClient.get(
      API_ENDPOINTS.FANTASYLEADERBOARD.GAMEWEEK(gameweekId),
    );
  },
  getUserRank: async (userId: number) =>
    apiClient.get(API_ENDPOINTS.FANTASYLEADERBOARD.USER_RANK(userId)),

  getStats: async (): Promise<FantasyLeaderboardStats> =>
    apiClient.get(API_ENDPOINTS.FANTASYLEADERBOARD.STATS),

  getTopPlayers: async (limit = 10): Promise<{ players: TopPlayer[] }> =>
    apiClient.get(
      `${API_ENDPOINTS.FANTASYLEADERBOARD.TOP_PLAYERS}?limit=${limit}`,
    ),

  getTopCaptains: async (limit = 10): Promise<{ captains: TopCaptain[] }> =>
    apiClient.get(
      `${API_ENDPOINTS.FANTASYLEADERBOARD.TOP_CAPTAINS}?limit=${limit}`,
    ),

  invalidateCache: async () =>
    apiClient.post(API_ENDPOINTS.FANTASYLEADERBOARD.INVALIDATE_CACHE),
};
